export default __webpack_public_path__ + "static/media/december-min.430b817a.jpg";